module.exports = {
    "page.im.window.oversize": "ဖိုင္အရြယ္အစား ၾကီးမားေနသည့္အတြက္ တင္၍မရပါ။ (50M ေအာက္နည္းရပါမည္)",
    "page.im.window.label.total": "စုစုေပါင္း",
    "page.import.footer.button.another": "ေနာက္တခုတင္မည္",
    "page.import.historyBox.link.downloadErrorReport": "ေဒါင္းလုဒ္မေအာင္ျမင္မွဳအစီရင္ခံခ်က္",
    "page.im.setting.current.desc": "ေရြးမွတ္ထားသည့္စာမ်က္ႏွာအားလုံးမွ",
    "page.im.setting.btn.addUser": "အသုံးျပဳသူထည့္ပါ",
    "page.im.window.draft": "အၾကမ္းမွတ္ထားျခင္း",
    "page.import.historyBox.feedback.success": "သင့္ဖိုင္တင္မွဳ ျပီးသြားပါျပီ",
    "page.im.setting.tab2": "အျမန္အေၾကာင္းျပန္ျခင္း",
    "page.im.setting.imForm.from": "မွ",
    "page.import.importBox.infos.2": "မွတ္ခ်က္၊ Excel ဖိုင္တြင္ Formula မ်ားႏွင့္ References မ်ား ပါဝင္ႏိုင္မည္မဟုတ္ပါ။",
    "page.im.window.orderSearchPlaceholder": "ေအာ္ဒါနံပါတ္ထည့္ေပးပါ",
    "page.import.historyBox.col.processed": "လုပ္ေဆာင္ျပီး",
    "page.im.window.label.emptyMessage": "မက္ေဆ့မရွိပါ။",
    "page.im.window.label.message": "ခ်က္",
    "page.import.historyBox.processed.table.col.warning": "သတိေပးခ်က္",
    "page.im.setting.imForm.to": "အထိ",
    "page.im.window.disconnection": "ကြန္ရက္ျပတ္ေတာက္မွဳ",
    "page.import.historyBox.feedback.failed": "သင့္ဖိုင္တင္မွဳမေအာင္ျမင္ပါ",
    "page.im.window.label.emptyList": "သင့္ဆိုင္တြင္ ဝယ္ယူမွဳမရွိေသးပါ။",
    "page.import.tab.history": "တင္သြင္းမွဳမွတ္တမ္း",
    "page.import.importBox.importModeText": "တင္မွဳပုံစံ",
    "page.im.setting.action": "Xiaobai Test",
    "page.im.setting.tab3": "အလိုအေလ်ာက္အေၾကာင္းျပန္ျခင္း",
    "page.im.window.unread": "မဖတ္ရေသး",
    "page.im.window.prdSearchPlaceholder": "ပစၥည္းအမည္ရိုက္ထည့္ေပးပါ",
    "page.im.setting.btn.createUser": "လုပ္ပိုင္ခြင့္အျပည့္အဝရွိသည့္ အသုံးျပဳသူအေကာင့္တခု လုပ္ပါ။",
    "page.im.window.label.orderTime": "ေအာ္ဒါမွာယူသည့္အခ်ိန္",
    "page.import.tab.template": "ၿပီးခဲ့ေသာ Template",
    "page.im.setting.confirm": "ယခုအုပ္စုအတြင္းမွ အသုံးျပဳသူကို ဖယ္ရွားရန္ ေသခ်ာပါသလား",
    "page.im.window.label.totalItems": "စုစုေပါင္းပစၥည္းအေရအတြက္",
    "page.import.importBox.infos.1": "ပစၥည္းအမ်ားအျပားတင္ရန္အတြက္ CSV (.csv) သို႔မဟုတ္ MS Excel (.xlsx) ဖိုင္မ်ားကို အသုံးျပဳႏိုင္ပါသည္။",
    "page.im.setting.btn.selectAll": "စာမ်က္ႏွာအားလုံးမွ",
    "page.im.setting.btn.clear": "ေရြးမွတ္ထားသည္မ်ားကို ရွင္းလင္းပါ",
    "page.import.importBox.templateTitle": "နမူနာပုံစံမ်ား ေဒါင္းလုဒ္ရယူမည္",
    "page.im.window.send": "ပို႔သည္",
    "page.import.historyBox.processed.table.col.failure": "မေအာင္ျမင္ပါ",
    "page.im.setting.assignment.subTitle": "သင့္ခ်က္အေကာင့္မ်ားကို ထိန္းခ်ဳပ္မည့္ ဝင္ေရာက္မွဳကို ျပဳလုပ္ေပးပါ။ သင့္တြင္ အသုံးျပဳသူအမ်ားအျပားရွိပါက၊ စကားေျပာဆိုထားသည့္ခ်က္အကုန္လုံးကို ၾကည့္ႏိုင္မည့္အေကာင့္ျဖစ္ပါသည္။ မွတ္ခ်က္၊ တင္သြင္းျပီးသည္ႏွင့္ ယခုအေကာင့္ကို ေျပာင္းလဲျခင္းျပဳလုပ္ႏိုင္မည္မဟုတ္ပါ။",
    "page.im.setting.init.confirm": "သတ္မွတ္ျပီးသည္ႏွင့္၊ အဓိကခ်က္အေကာင့္ကို ျပင္ဆင္၊ဖ်က္ပစ္ျခင္း ျပဳလုပ္ႏိုင္မည္မဟုတ္ပါ။ မွန္ကန္သည့္အေကာင့္ကို ေသခ်ာျဖည့္သြင္းေပးပါ။",
    "page.im.setting.assignment.title": "ပံုမွန္အသံုးျပဳမည့္ Chat အေကာင့္အား ေရြးခ်ယ္ပါ",
    "page.im.window.units": "အခုေရ",
    "page.im.window.read": "ဖတ္ျပီး",
    "page.import.historyBox.col.progress": "လုပ္ေဆာင္မွဳအဆင့္",
    "page.im.setting.management.title": "ဝယ္ယူသူဝန္ေဆာင္မွဳ",
    "page.import.importBox.infos.3": "Encoding format: UTF-8, separator: semicolon"
};